import { useMemo } from "react";

import type { OwnerListing } from "../../services/listings.service";

import useHostHubOwnerListings from "./useHostHubOwnerListings";

const METRO = "CHI";

type UseHostHubNonFsvChicagoListingsResult = {
  isError: boolean;
  isLoading: boolean;
  listings: OwnerListing[];
};

/**
 * Fetches the host's listings and checks if there are any CHI metro listings that are
 * NOT FSV listings
 */
const useHostHubNonFsvChicagoListings =
  (): UseHostHubNonFsvChicagoListingsResult => {
    const ownerListings = useHostHubOwnerListings();

    const listings = useMemo(
      () =>
        (ownerListings.listings ?? []).filter(
          (listing) => listing.metro === METRO && !listing.full_service,
        ),
      [ownerListings.listings],
    );

    return {
      isError: ownerListings.isError,
      isLoading: ownerListings.isLoading,
      listings,
    };
  };

export default useHostHubNonFsvChicagoListings;
